import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouterEvent } from '@angular/router';
import { ICtoContract, ICtoKkm } from '../../../core/models/cto.model';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';

@Component({
  selector: 'tax-cto-kkm',
  templateUrl: './cto-kkm.component.html',
  styleUrls: ['./cto-kkm.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoKkmComponent implements OnDestroy {
  private subscription: Subscription[] = [];
  // @ts-ignore
  @Input() kkm: ICtoKkm;
  // @ts-ignore
  @Input() contract: ICtoContract;

  constructor(
    private ctoApiService: CtoApiService,
    private changeDetector: ChangeDetectorRef,
  ) {
  }

  apply(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    event.preventDefault();
    this.subscription.push(this.ctoApiService.allowNewSim({
      kkmId: this.kkm.id.toString(),
      ctoIinOrBin: this.contract.cto.iinOrBin,
      // @ts-ignore
      simNumber: this.kkm.network.id,
    }).subscribe(
      (response) => {
        this.kkm.ctoEvents[0] = response;
        this.changeDetector.markForCheck();
      },
    ));
  }

  reject(event: Event | RouterEvent): void {
    if (event instanceof RouterEvent) return;

    event.preventDefault();
    this.subscription.push(this.ctoApiService.rejectNewSim({
      kkmId: this.kkm.id.toString(),
      ctoIinOrBin: this.contract.cto.iinOrBin,
      // @ts-ignore
      simNumber: this.kkm.network.id,
    }).subscribe(
      (response) => {
        this.kkm.ctoEvents[0] = response;
        this.changeDetector.markForCheck();
      },
    ));
  }

  ngOnDestroy(): void {
    this.subscription.forEach((item: Subscription) => item.unsubscribe());
  }
}
